import { useHealth } from "@/context/HealthContext";
import { HCard } from "@/components/health-kit";
import { Database, BrainCircuit, AlertTriangle, ShieldCheck, CheckCircle2, Activity, ScrollText } from "lucide-react";

export default function HumanLoop() {
  const { ht, overview } = useHealth();
  const steps = [
    { key: "hitl_ingest", icon: Database },
    { key: "hitl_ai", icon: BrainCircuit },
    { key: "hitl_signal", icon: AlertTriangle },
    { key: "hitl_gate", icon: ShieldCheck, gate: true },
    { key: "hitl_acr", icon: CheckCircle2 },
    { key: "hitl_action", icon: Activity },
    { key: "hitl_audit", icon: ScrollText },
  ];
  return (
    <div className="space-y-6 ngx-fade-in max-w-3xl mx-auto" data-testid="health-hitl">
      <div className="text-center">
        <h1 className="font-display text-2xl font-bold text-slate-50">{ht("nav_hitl")}</h1>
        <p className="text-sm text-slate-400 mt-1">{ht("aiSupports")}</p>
      </div>
      <div className="flex flex-col items-center gap-2">
        {steps.map((s, i) => (
          <div key={s.key} className="w-full flex flex-col items-center">
            <div className={`w-full max-w-md flex items-center gap-3 px-5 py-4 rounded-md border ${
              s.gate ? "border-teal-500 bg-teal-950/40 shadow-[0_0_24px_rgba(45,212,191,0.25)]" : "border-slate-700 bg-[#0A1620]"}`}
              data-testid={s.gate ? "hitl-gate" : undefined}>
              <s.icon className={`h-5 w-5 shrink-0 ${s.gate ? "text-teal-300" : "text-slate-400"}`} />
              <span className={`text-sm font-medium ${s.gate ? "text-teal-100" : "text-slate-200"}`}>{ht(s.key)}</span>
              {s.gate && <span className="ml-auto text-[10px] font-mono uppercase tracking-widest text-teal-400">{overview?.cases_requiring_review ?? 0}</span>}
            </div>
            {i < steps.length - 1 && <span className="text-slate-600 py-1">↓</span>}
          </div>
        ))}
      </div>
      <HCard className="p-4 border-teal-900/50 bg-teal-950/10 text-center">
        <p className="text-sm text-teal-200">{ht("gateNote")}</p>
      </HCard>
    </div>
  );
}
